module.exports = __webpack_public_path__ + "static/media/4.14_preview.ef2a4271.png";